import type { CityConfig } from "../city-template/types";

export const alexandriaVaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Virginia Department of Health Vital Records in Richmond. Online, mail, or walk-in at 2001 Maywill St.",
      url: "https://www.vdh.virginia.gov/vital-records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Virginia VDH Vital Records. Available online, by mail, or in person for estate and legal matters.",
      url: "https://www.vdh.virginia.gov/vital-records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage licenses from the Alexandria Circuit Court Clerk at 520 King St. Certified copies available for passport name changes.",
      url: "https://www.alexandriava.gov/ClerkOfCourt",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through Alexandria Circuit Court Clerk. Required for name change passport corrections.",
      url: "https://www.alexandriava.gov/ClerkOfCourt",
    },
  ],
  city: "Alexandria",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "alexandria-va",
  route: "/alexandria-va",
  title: "Emergency Passport Alexandria, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Alexandria, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Old Town, Del Ray, Carlyle, Fort Hunt, and all of Alexandria. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Alexandria, VA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Alexandria and Northern Virginia travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20historic%20waterfront%20scene%20of%20Old%20Town%20Alexandria%20Virginia%20at%20golden%20hour%20with%20cobblestone%20streets%2C%20colorful%20historic%20row%20houses%20along%20the%20Potomac%20River%2C%20King%20Street%20visible%20in%20the%20background%2C%20sailboats%20on%20the%20calm%20river%20water%2C%20warm%20amber%20sunset%20light%20reflecting%20off%20the%20buildings%2C%20lush%20green%20trees%20along%20the%20waterfront%2C%20professional%20travel%20photography%20with%20rich%20warm%20tones%20and%20sharp%20detail%2C%20no%20people%20visible&width=1800&height=700&seq=alexandria-va-hero-001&orientation=landscape",
  heroImageAlt: "Old Town Alexandria Virginia waterfront at golden hour with historic row houses and Potomac River",
  geoPosition: "38.8048;-77.0469",
  geoPlacename: "Alexandria, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 7 miles from Alexandria via I-395",
  },
  nearbyCitiesZips: [
    { name: "Alexandria", zips: "22301–22315, 22320, 22332, 22333" },
    { name: "Old Town", zips: "22314" },
    { name: "Del Ray", zips: "22301" },
    { name: "Carlyle", zips: "22314" },
    { name: "Eisenhower Valley", zips: "22314" },
    { name: "Seminary Hill", zips: "22304" },
    { name: "Rosemont", zips: "22301" },
    { name: "Arlandria", zips: "22305" },
    { name: "Beverly Hills", zips: "22305" },
    { name: "Fort Hunt", zips: "22308" },
    { name: "Belle Haven", zips: "22307" },
    { name: "Waynewood", zips: "22308" },
    { name: "Stratford Landing", zips: "22308" },
    { name: "Mount Vernon", zips: "22309" },
    { name: "Groveton", zips: "22306" },
    { name: "Hybla Valley", zips: "22306" },
    { name: "Huntington", zips: "22303" },
    { name: "Franconia", zips: "22310" },
    { name: "Kingstowne", zips: "22315" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Springfield", zips: "22150–22153" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22040–22046" },
    { name: "Lorton", zips: "22079" },
    { name: "Woodbridge", zips: "22191–22193" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Alexandria departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Historic Hub", desc: "Serving Old Town, Del Ray, Carlyle, Fort Hunt, and all of Alexandria" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Arlington VA passport services", route: "/arlington-va" },
    { name: "McLean VA passport services", route: "/mclean-va" },
    { name: "Washington DC passport services", route: "/dc" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Alexandria from our local office at 1629 K St NW in Washington, DC. Visit us by appointment, or use our courier pickup throughout Northern Virginia and the DC metro area.",
  fpcOfficeDistance: "1629 K St NW #300 — Washington, DC (approx. 8 miles from Alexandria)",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  serviceAreaIntro: "From the cobblestone streets and waterfront charm of Old Town to the vibrant neighborhood of Del Ray, from the modern Carlyle District to the historic homes of Fort Hunt and Belle Haven, from the suburban communities of Franconia and Kingstowne to the riverfront of Mount Vernon — Fast Passport Center serves every corner of Alexandria. We regularly help travelers from Arlington, Springfield, Annandale, and Lorton get their passports fast.",
  nearbyCitiesIntro: "We serve all Alexandria neighborhoods and the surrounding Northern Virginia metro area including Old Town, Del Ray, Carlyle, Eisenhower Valley, Seminary Hill, Rosemont, Arlandria, Fort Hunt, Belle Haven, Waynewood, Stratford Landing, Mount Vernon, Groveton, Hybla Valley, Huntington, Franconia, Kingstowne, Arlington, Springfield, Annandale, Falls Church, Lorton, and Woodbridge. If you are anywhere in the Alexandria or Northern Virginia region, we have you covered.",
  howItWorksIntro: "Most Alexandria travelers complete everything online and ship documents overnight. No need to drive into Washington, DC or wait in line at the regional agency.",
  servicesIntro: "Whether you need an emergency passport for a DCA international flight, a renewal before a Pentagon-ordered overseas deployment, or a first-time passport for a historic Old Town family booking their first European vacation — Fast Passport Center handles it with registered courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  mistakesIntro: "Alexandria travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Alexandria and Northern Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Alexandria? Here are the most common ones we hear from Alexandria travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "DCA flight to London in 48 hours? Pentagon deployment orders to Germany? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Alexandria-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Alexandria residents renew fast — no agency visit required for most renewals. Perfect for Old Town professionals, Del Ray families, and Carlyle federal contractors.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Alexandria residents through every step with clear instructions for the nearest acceptance location — from Old Town to Fort Hunt.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your DCA international connection or overseas government assignment stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Alexandria family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Alexandria professionals post-name-change.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Alexandria's defense contractors, State Department employees, and consultants traveling while primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a water-damaged or torn passport is faster than you think. We guide Alexandria travelers through the replacement so your overseas travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Alexandria VA", description: "Urgent passport processing for Alexandria Virginia travelers with immediate departure needs from DCA or IAD." },
    { name: "Expedited Passport Renewal Alexandria VA", description: "Fast passport renewal for Alexandria Virginia residents with a previously-issued passport." },
    { name: "First-Time Passport Alexandria VA", description: "New passport application services for Alexandria Virginia residents applying for their first passport." },
    { name: "Child Passport Alexandria VA", description: "Minor passport services for Alexandria Virginia families with children under 16." },
    { name: "Name Change Passport Alexandria VA", description: "Passport name correction after marriage, divorce, or legal name changes for Alexandria residents." },
    { name: "Second Passport Alexandria VA", description: "Second passport services for Alexandria defense contractors, federal employees, and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Patricia W.",
      location: "Old Town, Alexandria, VA",
      rating: 5,
      text: "My passport expired two weeks before a trip to Provence. Fast Passport Center had my renewal processed in 4 days. I shipped from the Old Town UPS and never had to leave Alexandria. Their service was exceptional.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas B.",
      location: "Del Ray, Alexandria, VA",
      rating: 5,
      text: "Emergency passport for a family crisis in Ireland. I thought I'd need to drive to DC and wait all day. Fast Passport Center got it done in 36 hours. They kept me informed at every stage. I was deeply grateful.",
      service: "Emergency Passport",
    },
    {
      name: "Rebecca S.",
      location: "Fort Hunt, Alexandria, VA",
      rating: 5,
      text: "First passports for our two teenagers before our safari trip to Kenya. Fast Passport Center handled the parental consent requirements and had both passports in 5 days. They made what seemed overwhelming feel completely manageable.",
      service: "Child Passport",
    },
    {
      name: "Andrew D.",
      location: "Carlyle, Alexandria, VA",
      rating: 5,
      text: "Lost my passport the day before a client meeting in Zurich. Fast Passport Center had a replacement in my hands in 26 hours. I still don't know how they pulled it off, but they saved my firm's biggest deal of the quarter.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "alexandria-va-1",
      name: "Alexandria Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 First St",
      city: "Alexandria",
      state: "VA",
      zip: "22314",
      phone: "(703) 549-5938",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Old Town Alexandria, near the waterfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Alexandria facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "alexandria-va-2",
      name: "Arlington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3118 Washington Blvd",
      city: "Arlington",
      state: "VA",
      zip: "22201",
      phone: "(703) 527-1204",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Arlington, north of Alexandria",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves north Alexandria and Arlington. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "alexandria-va-3",
      name: "Springfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6801 Commerce St",
      city: "Springfield",
      state: "VA",
      zip: "22150",
      phone: "(703) 569-4516",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Springfield, west of Alexandria",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Springfield and west Alexandria. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "alexandria-va-4",
      name: "Franconia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6500 Springfield Mall",
      city: "Springfield",
      state: "VA",
      zip: "22150",
      phone: "(703) 971-4261",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Franconia area, southwest of Alexandria",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Franconia and Kingstowne area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "alexandria-va-5",
      name: "Falls Church Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7777 Maple Pl",
      city: "Falls Church",
      state: "VA",
      zip: "22043",
      phone: "(703) 534-4621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Falls Church, north of Alexandria",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Falls Church and north Alexandria. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "alexandria-va-6",
      name: "Fairfax County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax County Government Center",
      website: "https://www.fairfaxcounty.gov/",
      websiteLabel: "Fairfax County Clerk",
      notes: "Major county facility for Fairfax County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Driving to Washington Agency Without an Appointment",
      description: "The Washington Passport Agency requires appointments even for emergencies. Many Alexandria residents arrive at 600 19th St NW without one and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Wrong Photo Size or Background",
      description: "Alexandria photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Alexandria applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Alexandria families at the clerk.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Alexandria travelers booking to Asia, the Middle East, or South America often don't know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your Alexandria travel date. Complete your secure order in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Get Your Checklist", description: "We confirm your situation and send a personalized document checklist — exactly what you need." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Overnight from Alexandria", description: "Drop at FedEx in Carlyle or UPS on King Street. Documents arrive at our processing center next morning." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through reserved agency slots — no I-395 drive to DC, no public appointment wait required." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within your selected timeframe and shipped directly back to you in Alexandria." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Alexandria before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Alexandria for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive into downtown Washington, DC." },
    { q: "How fast can I renew my passport in Alexandria?", a: "Fast Passport Center offers fast passport renewal in Alexandria in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Alexandria?", a: "The nearest regional passport agency to Alexandria is the Washington Passport Agency, located approximately 7 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Alexandria without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Alexandria?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Alexandria residents." },
    { q: "Can I expedite a child passport in Alexandria?", a: "Yes. Fast Passport Center expedites child passports in Alexandria for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Alexandria families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Alexandria with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Alexandria?", a: "With Fast Passport Center's emergency courier service, Alexandria travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Alexandria?", a: "Popular options include the Alexandria Main Post Office (22314), Arlington Main Post Office (22201), Springfield Post Office (22150), Franconia Post Office (22150), Falls Church Post Office (22043), and Fairfax County Clerk (22030). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Alexandria?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I work for the federal government or a defense contractor?", a: "Alexandria is home to a large population of federal employees, DoD contractors, and State Department personnel with unique travel demands. We handle short-notice passport processing for official and personal travel — including second passports for those whose primary passport is held for visa processing — with the discretion and urgency federal professionals require." },
    { q: "How much does expedited passport service cost in Alexandria?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Alexandria Residents",
    intro: "Alexandria's unique position at the nexus of federal government, international business, and three major airports creates distinct passport timing challenges. Here's what Alexandria travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "DCA — Ronald Reagan Washington National Airport",
        subtitle: "5 miles from Old Town — the local gateway for Alexandria residents",
        description: "DCA is the most convenient airport for Alexandria, with direct flights to major domestic destinations and expanding international service. The airport's proximity to the Pentagon and federal agencies means a constant stream of government travelers with short-notice international assignments. DCA's perimeter rule limits long-haul international routes, so many Alexandria travelers connect through East Coast hubs for overseas flights.",
        tip: "DCA's quick access from Alexandria can create a false sense of travel readiness — a passport issue discovered 48 hours before departure needs emergency courier processing, not a DCA visit.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "IAD — Dulles International Airport",
        subtitle: "30 miles west — the long-haul international hub for Northern Virginia",
        description: "Dulles serves as the primary international gateway for the entire Washington metro area, with direct flights to London, Frankfurt, Tokyo, Dubai, and dozens of global destinations. Alexandria's position between DCA and IAD means residents can choose between both airports depending on destination — but a passport urgency doesn't care which airport you're flying from.",
        tip: "International flights from Dulles often depart in the evening, giving Alexandria travelers a full workday to handle last-minute preparations — but passport processing doesn't wait. Start your application as soon as you book.",
      },
      {
        icon: "ri-building-2-line",
        title: "Federal Government & Defense Contractor Travel",
        subtitle: "Pentagon, State Department, DHS, and contractor deployments",
        description: "Alexandria's economy is deeply intertwined with the federal government and defense sector. The Pentagon is 3 miles away, Fort Belvoir is 15 miles south, and dozens of defense contractors maintain offices along the I-395 corridor. Short-notice overseas assignments, PCS moves, TDY deployments, and contractor site visits create a constant stream of passport urgencies that standard processing cannot accommodate.",
        tip: "Government travelers often need second passports when their primary passport is held for visa processing. We handle this specific scenario regularly for Alexandria's federal workforce.",
      },
      {
        icon: "ri-ship-line",
        title: "BWI — Baltimore/Washington International Airport",
        subtitle: "50 miles northeast — the third DC-area option for Alexandria travelers",
        description: "While BWI is farther from Alexandria than DCA or IAD, it offers competitive international fares and Southwest domestic connections that some Alexandria residents prefer. The drive up I-95 to BWI takes 50–70 minutes depending on traffic — and the last thing you want is to make that drive only to discover a passport issue at check-in.",
        tip: "Always check your passport validity before booking any flight — regardless of which DC-area airport you're departing from. A last-minute BWI international booking still requires a valid passport.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Alexandria & the I-395 Corridor Reality",
      description: "Alexandria sits at the epicenter of one of the most congested transportation corridors in the country. The Washington Passport Agency at 600 19th St NW is only 7 miles away — but can take 45–90 minutes during rush hour. Our courier service eliminates the I-395 drive entirely: complete everything online and ship overnight from any Alexandria UPS or FedEx location.",
    },
  },
  destinations: {
    title: "Where Alexandria Travelers Go — And Why Passports Get Urgent",
    intro: "Alexandria's international community, federal workforce, and three-airport access create travel patterns spanning every continent. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Alexandria expedited requests are government, military, or defense contractor-related with under 2 weeks notice" },
      { stat: "1–3 Weeks", label: "average lead time Alexandria travelers have from trip booking to international departure" },
      { stat: "May–Aug", label: "peak season when summer leave, PCS moves, and family vacation overlap with federal travel surges" },
      { stat: "26 Hours", label: "shortest turnaround we have accommodated for an Alexandria contractor departing to Dubai" },
    ],
    destinations: [
      { name: "United Kingdom", context: "British Airways direct from IAD and BWI to London Heathrow, defense cooperation travel, heritage tourism", urgency: "Government and contractor travel booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Lufthansa direct from IAD to Frankfurt, DoD PCS moves, contractor site visits, Ramstein Air Base rotations", urgency: "Military PCS orders create 2–3 week processing windows", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Direct flights from IAD to Tokyo, defense cooperation, tech contractor travel, diplomatic assignments", urgency: "TDY deployments booked 1–2 weeks out with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "Middle East", context: "Direct flights from IAD to Dubai and Doha, defense contractor deployments, diplomatic travel, development work", urgency: "Short-notice contractor travel dominates Middle East demand", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Cruise departures from Baltimore, DCA and IAD direct flights to Cancun and Caribbean destinations", urgency: "Last-minute cruise bookings and resort packages peak January–March", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Direct flights from IAD to Rome and Paris, heritage tourism from Alexandria's historic preservation community", urgency: "Summer vacation bookings peak April–June", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Virginia Service Areas",
    crossLinksDesc: "We serve travelers across Virginia with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Arlington", route: "/arlington-va" },
      { name: "McLean", route: "/mclean-va" },
      { name: "Richmond", route: "/richmond-va" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Old Town", address: "400 S Washington St, Alexandria, VA 22314", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Del Ray", address: "2600 Mount Vernon Ave, Alexandria, VA 22301", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Carlyle", address: "1700 Diagonal Rd, Alexandria, VA 22314", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Franconia", address: "6120 Franconia Rd, Alexandria, VA 22310", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Springfield", address: "7010 Old Keene Mill Rd, Springfield, VA 22150", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Arlington", address: "1700 N Moore St, Arlington, VA 22209", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Falls Church", address: "311 E Broad St, Falls Church, VA 22046", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Woodbridge", address: "14005 Jefferson Davis Hwy, Woodbridge, VA 22191", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Alexandria",
      address: "2681 Mill Rd, Alexandria, VA 22314",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Arlington",
      address: "4150 S Four Mile Run Dr, Arlington, VA 22204",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Springfield",
      address: "7764 Backlick Rd, Springfield, VA 22150",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Springfield and west Alexandria residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Woodbridge",
      address: "14916 Jefferson Davis Hwy, Woodbridge, VA 22191",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Prince William County and south Alexandria. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "5 miles north of Alexandria",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "The most convenient airport for Alexandria residents. Direct flights to major domestic destinations and international connections. Accessible via GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "30 miles west of Alexandria",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for long-haul flights to Europe, Asia, and the Caribbean. Accessible via I-495 and Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "50 miles northeast of Alexandria",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};